import { render, staticRenderFns } from "./block-footer.vue?vue&type=template&id=379d1cd0&scoped=true"
import script from "./block-footer.vue?vue&type=script&lang=js"
export * from "./block-footer.vue?vue&type=script&lang=js"
import style0 from "./block-footer.vue?vue&type=style&index=0&id=379d1cd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379d1cd0",
  null
  
)

export default component.exports